import { AxiosPromise } from 'axios';
import { IrPrivateCommunication } from '../store/irClaimSlice';
import api from './api';

export default function createPrivateComment(update: Partial<IrPrivateCommunication>) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.post('/ir-private-communications', update)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
